import React from 'react';

import BaseModal from 'src/components/Modal/BaseModal';
import WorkflowForm from './WorkflowForm';

interface Props {
    isOpen?: boolean,
    onClose: () => void,
    onSuccess?: (res: any) => void,
}

function WorkflowModal({ isOpen, onClose, onSuccess }: Props) {
  return (
    <BaseModal
      onClose={onClose}
      title="Create workflow"
      isOpen={isOpen}
    >
      <WorkflowForm
        onSuccess={(res: any) => {
          if (onSuccess) onSuccess(res);
          onClose();
        }}
      />
    </BaseModal>
  );
}

WorkflowModal.defaultProps = {
  onCancel: () => {},
  open: false
};

export default WorkflowModal;
